import React, { forwardRef } from "react";
import Barcode from "react-barcode";

const AllBarcodesPrint = forwardRef(({ items }, ref) => {
  console.log("All Barcodes PRINT console items", items);
  const itemsPerRow = 4; // Number of columns per row

  const rows = [];
  for (let i = 0; i < items.length; i += itemsPerRow) {
    const rowItems = items.slice(i, i + itemsPerRow).map((currentItem, index) => (
      <div key={i + index} style={{ margin: "0 20px",padding:"0 20px", flex: "1", textAlign: "center" }}>
        <div>{currentItem.itemName}</div>
        <Barcode
          value={currentItem.barcode ? currentItem.barcode : currentItem._id}
          width={1}
          height={50}
          displayValue={true}
          fontSize={12}
        />
      </div>
    ));

    rows.push(
      <div key={i} style={{ display: "flex", justifyContent: "center", margin: "10px 20px" }}>
        {rowItems}
      </div>
    );
  }

  return <div ref={ref}>{rows}</div>;
});

export default AllBarcodesPrint;
